import { CSSProperties } from 'react'

import classNames from 'classnames'

interface ItemProps {
  className?: string
  style?: CSSProperties
  children?: React.ReactNode
  flash?: boolean
}

export const SublistItem: React.FC<ItemProps> = ({
  className,
  style,
  children,
  flash,
}) => {
  return (
    <div
      className={classNames('sublist-item', { flash }, className)}
      style={{ ...style }}
    >
      {children}
    </div>
  )
}
